import axios from 'axios';
import api from './api';

// Tripay configuration APIs
export const tripayConfigAPI = {
  getConfig: async () => {
    const response = await api.get('/tripay/config');
    return response.data;
  },

  toggleEnabled: async (is_enabled: boolean) => {
    const response = await api.patch('/tripay/config/enabled', { is_enabled });
    return response.data;
  },

  updateConfig: async (configData: {
    api_key: string;
    private_key: string;
    merchant_code: string;
    is_production: boolean;
    callback_url?: string;
    return_url?: string;
  }) => {
    const response = await api.put('/tripay/config', configData);
    return response.data;
  },
};

// Tripay payment APIs
export const tripayPaymentAPI = {
  getPaymentMethods: async () => {
    const response = await api.get('/tripay/payment-methods');
    return response.data;
  },

  createPayment: async (paymentData: {
    bill_id: string;
    payment_method: string;
    customer_data?: {
      name?: string;
      email?: string;
      phone?: string;
    };
  }) => {
    const response = await api.post('/tripay/create-payment', paymentData);
    return response.data;
  },

  getPaymentDetail: async (reference: string) => {
    const response = await api.get(`/tripay/payment/${reference}`);
    return response.data;
  },

  checkPaymentStatus: async (reference: string) => {
    const response = await api.get(`/tripay/status/${reference}`);
    return response.data;
  },

  getBillPayments: async (billId: string) => {
    const response = await api.get(`/tripay/bill/${billId}/payments`);
    return response.data;
  },

  getAllPayments: async (params?: {
    page?: number;
    limit?: number;
    status?: string;
    customer_name?: string;
  }) => {
    const response = await api.get('/tripay/payments', { params });
    return response.data;
  },
};

// Public payment APIs (no auth required)
export const publicPaymentAPI = {
  getBillDetail: async (billId: string) => {
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
    const response = await axios.get(`${apiUrl}/public/payment/bill/${billId}`);
    return response.data;
  },

  getPaymentMethods: async () => {
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
    const response = await axios.get(`${apiUrl}/public/payment/payment-methods`);
    return response.data;
  },

  createPayment: async (paymentData: {
    bill_id: string;
    payment_method: string;
    customer_name: string;
    customer_email: string;
    customer_phone?: string;
    replace_existing?: boolean;
  }) => {
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
    const response = await axios.post(`${apiUrl}/public/payment/create-payment`, paymentData);
    return response.data;
  },

  checkPaymentStatus: async (reference: string) => {
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
    const response = await axios.get(`${apiUrl}/public/payment/status/${reference}`);
    return response.data;
  },

  getPaymentDetail: async (reference: string) => {
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
    const response = await axios.get(`${apiUrl}/public/payment/payment/${reference}`);
    return response.data;
  },

  checkExistingPayment: async (billId: string) => {
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
    const response = await axios.get(`${apiUrl}/public/payment/bill/${billId}/existing-payment`);
    return response.data;
  },

  getGatewaysStatus: async () => {
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
    const response = await axios.get(`${apiUrl}/public/payment/gateways-status`);
    return response.data;
  },
};

export default {
  config: tripayConfigAPI,
  payment: tripayPaymentAPI,
  public: publicPaymentAPI,
};
